import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";

import { useSnackbar } from "@app/components";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { selectIsAuthenticated } from "@app/modules/common";
import {
  selectLoginState,
  selectVerifyOTPState,
} from "@app/modules/auth/selectors";
import { login, resetLoginState, verifyOtp } from "@app/modules/auth/slice";
import { LoginDialog, OtpVerificationsDialog } from "@app/modules/auth";
import useResponsive from "./use-responsive";
import { useRequestState } from "./use-request-state";

export const useAuthCheck = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useResponsive("down", "md");
  const { enqueueSnackbar } = useSnackbar();

  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loginState = useSelector(selectLoginState);
  const verifyData = useSelector(selectVerifyOTPState);

  const [openLogin, setOpenLogin] = useState(false);
  const [openOtp, setOpenOtp] = useState(false);
  const [loginFormData, setLoginFormData] = useState<any>(null);

  const startLoginFlow = () => {
    if (isAuthenticated) {
      return;
    }
    dispatch(resetLoginState());
    setOpenLogin(true);
  };

  const handleLoginSuccess = (formData: any) => {
    setLoginFormData(formData);
    setOpenLogin(false);
    setOpenOtp(true);
  };

  const handleOtpClose = () => {
    setOpenOtp(false);
  };

  // useEffect(() => {
  //   if (verifyData?.status === 2) {
  //     enqueueSnackbar("OTP verified successfully!", { variant: "success" });
  //     setOpenOtp(false);
  //     navigate(PATH_DASHBOARD.myProfile);
  //   } else if (verifyData?.status === 3) {
  //     const errorMsg =
  //       Array.isArray(verifyData?.error?.message)
  //         ? verifyData?.error?.message[0]
  //         : verifyData?.error?.message || "Invalid OTP";
  //     enqueueSnackbar(errorMsg, { variant: "error" });
  //   }
  // }, [verifyData]);

  useRequestState({
    stateSelector: selectVerifyOTPState,
    onSuccess: () => {
      enqueueSnackbar("OTP verified successfully!", { variant: "success" });
      setOpenOtp(false);
      setOpenLogin(false)
      navigate(PATH_DASHBOARD.myProfile);
    },
    onFailed: () => {
      const errorMsg = Array.isArray(verifyData?.error?.message)
        ? verifyData?.error?.message[0]
        : verifyData?.error?.message || "Invalid OTP";
      enqueueSnackbar(errorMsg, { variant: "error" });
    },
  });

  const LoginDialogJSX = (
    <LoginDialog
      open={openLogin}
      onClose={() => setOpenLogin(false)}
      onClickOtpVerificationsDialog={() => {
        setOpenLogin(false);
        setOpenOtp(true);
      }}
      setLoginFormData={setLoginFormData}
    />
  );

  const OtpDialogJSX = (
    <OtpVerificationsDialog
      open={openOtp}
      onClose={handleOtpClose}
      loginFormData={loginFormData}
    />
  );

  return {
    startLoginFlow,
    LoginDialog: LoginDialogJSX,
    OtpDialog: OtpDialogJSX,
  };
};
